import { useEffect, useState } from "react";
import useErrorHandler from "../FormErrorHandler";
import {
  FormInputRow,
  FormSection,
  FormHeader,
  RadioInput,
} from "../../FormInput/FormInput";
import InjuriesInfoList from "../InjuriesInfoList";

const GettingStarted = ({ formData, handleInputChange, validateForm }) => {
  const { error, addError, clearError, hasError } = useErrorHandler();

  const handlePassengersSelected = (fieldName, value, parentField) => {
    handleInputChange(fieldName, value, parentField);
    if (value == "No") handleInputChange("passengersInvehiclesLists", []);
  };

  const handleInjuriesSelected = (fieldName, value, parentField) => {
    handleInputChange(fieldName, value, parentField);
    if (value == "No") 
      handleInputChange("injuriesInLossLists", []);
  };

  const validate = async (formData) => {
    clearError();
    let hasValidationError = false;

    if (!formData.anyOtherVehiclesInvolved) {
      addError({ anyOtherVehiclesInvolved: "This field is required" });
    }
    if (!formData.wereThereAnyPassengersInVehicle) {
      addError({ wereThereAnyPassengersInVehicle: "This field is required" });
    }
    if(formData.wereThereAnyPassengersInVehicle == "No"){
      if (!formData.wereThereAnyInjuriesInLoss) {
        addError({ wereThereAnyInjuriesInLoss: "This field is required" });
      } else if (formData.wereThereAnyInjuriesInLoss == "Yes") {
        let hasSetFocused = false;
        for (const person of formData.injuriesInLossLists) {
          if (typeof person.validate === "function") {
            const isValid = await person.validate(person);
            if (!isValid) {
              hasValidationError = true;
              if(!hasSetFocused){
                person.setIsFocused(true)
                hasSetFocused = true
              }
            }
          } else {
            hasValidationError = true;
          }
        }
      }
    }

    return !hasError() && !hasValidationError;
  };

  validateForm.current = validate;

  return (
    <div>
      <FormHeader>ADDITIONAL INFORMATION</FormHeader>
      <FormSection>
        <FormInputRow header="Were there any other vehicles or property damaged in the loss?*">
          <RadioInput
            fieldName="anyOtherVehiclesInvolved"
            value={formData.anyOtherVehiclesInvolved}
            handleInputChange={handleInputChange}
            sameLine={true}
            error={error}
            options={[
              { label: "Yes", value: "Yes" },
              { label: "No", value: "No" },
            ]}
          />
        </FormInputRow>
        <FormInputRow header="Were there any passengers in your vehicle?*">
          <RadioInput
            fieldName="wereThereAnyPassengersInVehicle"
            value={formData.wereThereAnyPassengersInVehicle}
            handleInputChange={handlePassengersSelected}
            sameLine={true}
            error={error}
            options={[
              { label: "Yes", value: "Yes" },
              { label: "No", value: "No" },
            ]}
          />
        </FormInputRow>
        {formData.wereThereAnyPassengersInVehicle == "No" && (
          <>
            <FormInputRow header="Were any other individuals injured in this loss?*">
              <RadioInput
                fieldName="wereThereAnyInjuriesInLoss"
                value={formData.wereThereAnyInjuriesInLoss}
                handleInputChange={handleInjuriesSelected}
                sameLine={true}
                error={error}
                options={[
                  { label: "Yes", value: "Yes" },
                  { label: "No", value: "No" },
                ]}
              />
            </FormInputRow>

            {formData.wereThereAnyInjuriesInLoss == "Yes" && (
              <InjuriesInfoList
                formData={formData}
                handleInputChange={handleInputChange}
                validateForm={validateForm}
              />
            )}
          </>
        )}
      </FormSection>
    </div>
  );
};

export default GettingStarted;
